function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9 19v-2.2c0-1.8 1.3-3.2 3-3.2s3 1.4 3 3.2V19H9zm-1 2H3l2-9.1 2.6-2.2.4-3.3L15 4l1.6 5.6 2.4.9L21 21H8z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgLocationCave = function SvgLocationCave(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationCave;